import axios from "../axios";

const createSchedule = (payload) => axios.post(`schedule`, payload);

const fetchSchedules = () => axios.get(`schedule`);

const updateSchedule = (scheduleId, payload) =>
  axios.post(`schedule/${scheduleId}`, payload);

const deteleSchedule = (playlistId) => axios.delete(`schedule/${playlistId}`);

export { createSchedule, deteleSchedule, fetchSchedules, updateSchedule };
